import {Component,OnInit} from '@angular/core';
import {FormulaireOmpService} from "@components/admin/parametre/formulaire/formulaire-omp/formulaire-omp.service";
import {BehaviorSubject} from "rxjs";
import {FloatingButtonAction,TypeAction} from "@share/component/floating-button/floating-button";
import {DateDebutOption,DateFinOption} from "@domain/admin/parametre/formulaire/param-omp";
import {TranslateService} from "@ngx-translate/core";

/**
 * Composant d'affichage de la page formulaire pour l'omp
 *
 * @author Lionel Gimenez
 * @date 04/09/2025
 */
@Component({
    host: {'data-test-id': 'formulaire-omp'},
    selector: 'formulaire-omp',
    templateUrl: './formulaire-omp.component.html'
})
export class FormulaireOmpComponent implements OnInit {
    /** Liste des actions possibles */
    listeActions: BehaviorSubject<Array<FloatingButtonAction>> = new BehaviorSubject<Array<FloatingButtonAction>>(null);

    /** Liste des options de date de début */
    dateDebutOptionListe: Array<{ type: DateDebutOption,libelle: string }>;

    /** Liste des options de fin de début */
    dateFinOptionListe: Array<{ type: DateFinOption,libelle: string }>;

    /**
     * Constructeur
     */
    constructor(
        public formulaireOmpService: FormulaireOmpService,
        private translateService: TranslateService,
    ) {
    }

    /**
     * Initialisation
     */
    ngOnInit(): void {
        //Initialisation des listes d'options
        this.initOptionsListes();

        //Chargement des données
        this.formulaireOmpService.load();

        //Initialisation des actions possibles
        this.listeActions.next([{
            type: TypeAction.PRIMARY,
            icone: 'nio icon-sauvegarde',
            libelle: 'global.actions.enregistrer',
            doAction: () => this.formulaireOmpService.save(),
        }]);
    }

    /**
     * Initialise les listes d'options pour les sélecteurs
     */
    private initOptionsListes(): void {
        /** Liste des options de date de début */
        this.dateDebutOptionListe = [
            {
                type: DateDebutOption.AUCUNE,
                libelle: this.translateService.instant("admin.parametres.formulaire.omp.dateDebutOption.aucune")
            },
            {
                type: DateDebutOption.DATE_JOUR,
                libelle: this.translateService.instant("admin.parametres.formulaire.omp.dateDebutOption.dateJour")
            },
            {
                type: DateDebutOption.DATE_DEBUT_EXERCICE,
                libelle: this.translateService.instant("admin.parametres.formulaire.omp.dateDebutOption.premierJourAnnee")
            },
            {
                type: DateDebutOption.DATE_DEBUT_ANNEE,
                libelle: this.translateService.instant("admin.parametres.formulaire.omp.dateDebutOption.premierJourExercice")
            }
        ];

        /** Liste des options de fin */
        this.dateFinOptionListe = [
            {
                type: DateFinOption.AUCUNE,
                libelle: this.translateService.instant("admin.parametres.formulaire.omp.dateFinOption.aucune")
            },
            {
                type: DateFinOption.DATE_JOUR,
                libelle: this.translateService.instant("admin.parametres.formulaire.omp.dateFinOption.dateJour")
            },
            {
                type: DateFinOption.DATE_FIN_EXERCICE,
                libelle: this.translateService.instant("admin.parametres.formulaire.omp.dateFinOption.dernierJourAnnee")
            },
            {
                type: DateFinOption.DATE_FIN_ANNEE,
                libelle: this.translateService.instant("admin.parametres.formulaire.omp.dateFinOption.dernierJourExercice")
            }
        ];

    }
}